import { Search, Filter, X } from 'lucide-react'

function InvoiceFilters({
  searchTerm,
  paymentStatus,
  orderStatus,
  onSearchChange,
  onPaymentStatusChange,
  onOrderStatusChange,
  onClearFilters,
  totalItems
}) {
  return (
    <div className="card">
      <div className="card-content">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
          <div>
            <label className="label">Search</label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-secondary-400" />
              <input
                type="text"
                placeholder="Search invoices..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="input pl-10"
              />
            </div>
          </div>
          <div>
            <label className="label">Payment Status</label>
            <select
              value={paymentStatus}
              onChange={(e) => onPaymentStatusChange(e.target.value)}
              className="input"
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Partial">Partial</option>
              <option value="Paid">Paid</option>
              <option value="Overdue">Overdue</option>
            </select>
          </div>
          <div>
            <label className="label">Order Status</label>
            <select
              value={orderStatus}
              onChange={(e) => onOrderStatusChange(e.target.value)}
              className="input"
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
          <div className="flex items-end">
            <button
              onClick={onClearFilters}
              className="btn-outline w-full"
            >
              <Filter className="h-4 w-4 mr-2" />
              Clear Filters
            </button>
          </div>
        </div>
        {totalItems !== undefined && (
          <div className="mt-4 text-base text-secondary-600">
            Showing {totalItems} invoice{totalItems !== 1 ? 's' : ''}
          </div>
        )}
      </div>
    </div>
  )
}

export default InvoiceFilters

